import axios from 'axios';
import React, { useState, useEffect }  from 'react';
import { Button, Container, Row, Col, Card, Form , Spinner  } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false); // State for form validation

  //when login is given in url,redirected to the joblisting page
   useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // User is already logged in, redirect to the desired page
      navigate('/JobListing');
      // navigate((location.state && location.state.from) || '/');
    }
  }, [navigate]);


  const handleLogin = async (event) => {
    event.preventDefault(); // Prevent default form submission
    const form = event.currentTarget;
    
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setIsLoading(true);
      const userData = {
        "Username": username,
        "Password": password
      };

      try {
        const response = await axios.post(`https://ascent-talents.com:8009/auth`, userData);
        const { token, user } = response.data; 
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        toast.success('Logged in successfully');
        navigate('/JobListing');
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      } finally {
        setIsLoading(false);
      }
    }

    setValidated(true); // Mark the form as validated
  };

  return (
    <body style={{ backgroundColor: '#F7F9FF' }}>
      <Container fluid className="vh-100">
        <Row className='  justify-content-center align-items-center h-100'>
          <Col xs={12}>
            <Card
              className='my-5 mx-auto'
              style={{
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                maxWidth: '500px',
                border: 'none',
                borderRadius: '10px',
                backgroundColor: '#172446'
              }}
            >
              <Card.Body className='w-100 d-flex flex-column'  style={{ paddingTop: '0px',paddingBottom:'40px', paddingLeft:'30px', paddingRight:'30px'}}>
                <img src={process.env.PUBLIC_URL + '/assets/images/AscentLogo.png'} alt="Logo" className="mb-2  mx-auto" style={{ width: '140px', height: '110px'  }} />
                <h2 className="fw-normal fs-4 mb-2 text-center" style={{paddingTop: '0px',paddingBottom:'20px',color:'#f0f0f0',fontFamily:'segoe ui'}}>Sign in with</h2>
                <Form noValidate validated={validated} onSubmit={handleLogin}>

                  <Form.Group className='mb-4 w-100'>
                    <Form.Label className="fw-semibold" style={{color:'#f0f0f0',fontFamily:'segoe ui'}}>Username</Form.Label>
                    <Form.Control type='text' size="lg" value={username} onChange={(e) => setUsername(e.target.value)} required />
                    <Form.Control.Feedback type="invalid">Please provide a valid username.</Form.Control.Feedback>
                  </Form.Group>
                  
                  <Form.Group className='mb-4 w-100'>
                    <Form.Label className="fw-semibold" style={{color:'#f0f0f0',fontFamily:'segoe ui'}}>Password</Form.Label>
                    <Form.Control type='password' size="lg" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <Form.Control.Feedback type="invalid">Please provide a valid password.</Form.Control.Feedback>
                  </Form.Group>

 {/* Remember Password checkbox */}
 <Form.Group className="mb-4 d-flex align-items-center">
    <Form.Check type='checkbox' id='rememberPassword' className='me-2' />
    <Form.Label className='mb-0 me-3 ' style={{color:'#FFE114',fontFamily:'segoe ui'}}>Remember password</Form.Label>
    {/* <a href="#" className="text-decoration-none" style={{color:'#FFE114',fontFamily:'segoe ui'}}>Forgot password?</a> */}
  </Form.Group>

                  <div className='text-center'>
                  <Button className="fw-semibold" size='lg' style={{ backgroundColor: '#FFE114', color: '#172446', border: 'none',fontFamily:'segoe ui' }} type="submit" disabled={isLoading}>
                    {isLoading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        Logging in...
                      </>
                    ) : (
                      'Login'
                    )}
                  </Button>
                  </div>
                </Form>
                <ToastContainer/>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </body>
  );
}

export default Login;
